import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import Progress from 'react-progressbar';
import { showBigImage, hideImage, bomConfigData } from '../../../../Components/helper';
import SupplierTodoExapandView from './SupplierTodoExapandView';
import Loader from '../../../../Components/Utility/Loader/Loader';
import noImage from '../../../../assets/images/no-image.png';
import * as todoAction from './store/SupplierToDo.action';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';

function SupplierList({ loading, selectedColumns, subBrandAccess }) {
  const [state, setState] = useState({
    supplierStateList: [],
    hasMore: true,
    loading: false,
    selectedIdsArray: [],
    isSelectAll: false,
    dateData: [],
  });
  const dispatch = useDispatch();

  const { isSelectAll, supplierStateList, selectedIdsArray } = state;

  const {
    SupplierTodoModule: {
      supplierTodoList,
      supplierFilterValues: { sortOrder, sortPropertyName, searchText, pageSize },
    },
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reduxState) => reduxState);
  const { t } = useTranslation('common');
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  const handleSelection = (id) => {
    let selectIds = [...selectedIdsArray];
    if (typeof id === 'boolean') {
      setState((prevState) => ({
        ...prevState,
        isSelectAll: id,
      }));
      if (!id) selectIds = [];
      else selectIds = supplierTodoList.map((ele) => ele._id);
    } else if (id) {
      const itemIndex = selectIds.findIndex((val) => val === id);
      if (itemIndex >= 0) selectIds.splice(itemIndex, 1);
      else selectIds.push(id);
      if (selectIds.length !== supplierTodoList.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: false,
        }));
      } else if (selectIds.length === supplierTodoList.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: true,
        }));
      }
    }
    setState((prevState) => ({
      ...prevState,
      selectedIdsArray: selectIds,
    }));
  };
  const toggleExpanfView = (index) => {
    const cloneSampleTodoList = supplierStateList;
    cloneSampleTodoList[index].isExpanded = !cloneSampleTodoList[index].isExpanded;
    setState((prevState) => ({
      ...prevState,
      supplierStateList: cloneSampleTodoList,
    }));
  };
  const renderExpandButton = (index, isExpanded) => {
    const buttonClassName = 'btn-up-down';
    const onClick = () => {
      toggleExpanfView(index);
    };
    const iconClassName = isExpanded ? 'icon-new-down-arrow-icon icon-inverse' : 'icon-new-down-arrow-icon';

    return (
      <button className={buttonClassName} onClick={onClick} type="button">
        <span className={iconClassName} />
      </button>
    );
  };

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(supplierTodoList)) {
      setState((prevState) => ({
        ...prevState,
        supplierStateList: supplierTodoList,
      }));
    }
  }, [supplierTodoList]);

  const headerSortingIcon = (lable, propertyName, _orderType) => {
    return (
      <span className="cursor-pointer">
        {lable}
        {sortPropertyName === propertyName ? (
          <>
            {sortOrder === '' && <i className="fa fa fa-sort ml-1" />}
            {sortOrder === 'Asc' && <i className="fa fa fa-sort-up ml-1" />}
            {sortOrder === 'Desc' && <i className="fa fa fa-sort-desc ml-1" />}
          </>
        ) : (
          <i className="fa fa fa-sort ml-1" />
        )}
      </span>
    );
  };

  const onSortColumn = async (propertyName) => {
    if (sortOrder === '' || sortOrder === 'Desc') {
      const sortObj = {
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
        searchText,
        pageIndex: 1,
        pageSize,
        type: 'supplier-todo',
      };
      const obj = {
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
      };
      await dispatch(todoAction.filterSortData(obj));
      await dispatch(todoAction.getSupplierTodoList(sortObj));
    } else {
      const sortObj = {
        sortOrder: 'Desc',
        sortPropertyName: propertyName,
        searchText,
        pageIndex: 1,
        pageSize,
        type: 'supplier-todo',
      };
      await dispatch(todoAction.getSupplierTodoList(sortObj));
      const obj = {
        sortOrder: 'Desc',
        sortPropertyName: propertyName,
      };
      await dispatch(todoAction.filterSortData(obj));
    }
  };
  return supplierStateList?.length > 0 ? (
    <table className="table custom-table layout-fixed font-13 text-center customTable todo-fixed-col-table fixed-col-table-costing fixed-col-table-supplier-todo ">
      <thead>
        <tr>
          <th className="w-80px w-xs-40px">
            <div className="checkbox-label no-label margin-auto">
              <input
                type="checkbox"
                onChange={(e) => handleSelection(e.target.checked)}
                name="check_all_samples"
                id="check_all_samples"
                checked={isSelectAll}
                disabled={!supplierStateList.length}
              />
              <label htmlFor="check_all_samples" className="chklabel">
                <span />
              </label>
            </div>
          </th>
          <th className="w-80px" />
          <th className="w-80px">Image</th>
          <th className="w-150px last-fix-col" onClick={() => onSortColumn('number')}>
            {headerSortingIcon('Product Ref', 'number', sortOrder)}
          </th>
          {selectedColumns?.includes('Brand') && (
            <th className="w-150px" onClick={() => onSortColumn('brandId')}>
              {headerSortingIcon(t('TABLE_HEADERS.BRAND'), 'brandId', sortOrder)}
            </th>
          )}
          {selectedColumns?.includes('Sub Brand') && subBrandAccess && (
            <th className="w-150px" onClick={() => onSortColumn('subBrandId')}>
              {headerSortingIcon('Sub Brand', 'subBrandId', sortOrder)}
            </th>
          )}
          {selectedColumns?.includes('Supplier') && (
            <th className="w-150px" onClick={() => onSortColumn('suppliers')}>
              {headerSortingIcon('Supplier', 'suppliers', sortOrder)}
            </th>
          )}
          {selectedColumns?.includes('Season') && (
            <th className="w-150px " onClick={() => onSortColumn('seasonId')}>
              {headerSortingIcon(t('TABLE_HEADERS.SEASON'), t('TABLE_HEADERS.SEASON_ID'), sortOrder)}
            </th>
          )}

          {selectedColumns?.includes('Month') && (
            <th className="w-150px" onClick={() => onSortColumn('month')}>
              {headerSortingIcon(t('TABLE_HEADERS.MONTH'), t('TABLE_HEADERS.MONTHS'), sortOrder)}
            </th>
          )}

          {selectedColumns?.includes('Year') && (
            <th className="w-150px" onClick={() => onSortColumn('year')}>
              {headerSortingIcon(t('TABLE_HEADERS.YEAR'), t('TABLE_HEADERS.YEARS'), sortOrder)}
            </th>
          )}
          {(selectedColumns?.includes('productType') || catBasedOnPTData) && (
            <th className="w-150px" onClick={() => onSortColumn('productType')}>
              {headerSortingIcon(t('TABLE_HEADERS_LIST.PRODUCT_TYPE'), t('TABLE_HEADERS_LIST.PRODUCT_TYPE_ID'), sortOrder)}
            </th>
          )}
          {selectedColumns?.includes('Category 1') && (
            <th className="w-150px" onClick={() => onSortColumn('catOneId')}>
              {headerSortingIcon('Category 1', t('TABLE_HEADERS.CAT_ONE_ID'), sortOrder)}
            </th>
          )}

          {selectedColumns?.includes('Category 2') && (
            <th className="w-150px" onClick={() => onSortColumn('catTwoId')}>
              {headerSortingIcon('Category 2', t('TABLE_HEADERS.CAT_TWO_ID'), sortOrder)}
            </th>
          )}

          {selectedColumns?.includes('Category 3') && (
            <th className="w-150px" onClick={() => onSortColumn('catThreeId')}>
              {headerSortingIcon('Category 3', t('TABLE_HEADERS.CAT_THREE_ID'), sortOrder)}
            </th>
          )}

          {selectedColumns?.includes('Category 4') && (
            <th className="w-150px" onClick={() => onSortColumn('catFourId')}>
              {headerSortingIcon('Category 4', t('TABLE_HEADERS.CAT_FOR_ID'), sortOrder)}
            </th>
          )}
          <th className="w-150px"> {t('SUPPLIER_TO_DO.COMPLETION')}</th>
          <th className="w-150px"> {t('SUPPLIER_TO_DO.LOCATION')}</th>
          <th className="w-150px"> {t('SUPPLIER_TO_DO.FIELDS')}</th>
          <th className="w-120px"> {t('SUPPLIER_TO_DO.ACTIONS')}</th>
        </tr>
      </thead>

      <tbody>
        {supplierStateList?.length > 0 &&
          supplierStateList?.map((data, idx) => {
            let locationVl;
            if (data?.expandData?.length > 1) {
              locationVl = 'Multiple';
            } else {
              const expand = data?.expandData?.[0];
              locationVl = `${expand?.module} > ${expand?.bomType?.name}`;
              if (expand?.placement) {
                locationVl += ` > ${expand.placement}`;
              }
            }

            const fields = data?.expandData?.[0]?.bomFields?.length > 1 ? 'Multiple' : data?.expandData?.[0]?.bomFields?.[0];

            const fieldLabel = fields === 'Multiple' ? 'Multiple' : bomConfigData.find((item) => item.value === fields)?.label || fields;
            return (
              <>
                <tr key={data?._id}>
                  <td>
                    <div className="checkbox-label no-label margin-auto">
                      <input
                        onChange={() => {
                          handleSelection(data?._id);
                        }}
                        name={`checks_${idx}`}
                        id={`checks_${idx}`}
                        type="checkbox"
                        checked={selectedIdsArray?.includes(data?._id)}
                      />
                      <label htmlFor={`checks_${idx}`} className="chklabel">
                        <span />
                      </label>
                    </div>
                  </td>
                  <td>{data?.expandData && data?.expandData.length > 0 ? renderExpandButton(idx, data.isExpanded) : null}</td>
                  <td>
                    <div className="image-detail hover-right">
                      <figure onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
                        <div className="img-preview-inside-table sm">
                          <img width="60" alt="product img" src={data.image || noImage} />
                        </div>
                      </figure>
                    </div>
                  </td>
                  <td className="last-fix-col">{data?.number || '--'}</td>
                  {selectedColumns?.includes('Brand') && <td>{data?.brandId || '--'}</td>}
                  {selectedColumns?.includes('Sub Brand') && subBrandAccess && <td>{data?.subBrandId || '--'}</td>}
                  {selectedColumns?.includes('Supplier') && <td className="w-150px">{data?.suppliers || '--'}</td>}
                  {selectedColumns?.includes('Season') && <td>{data?.seasonId || '--'}</td>}
                  {selectedColumns?.includes('Month') && <td>{data?.month || '--'}</td>}
                  {selectedColumns?.includes('Year') && <td>{data?.year || '--'}</td>}
                  {(selectedColumns?.includes('productType') || catBasedOnPTData) && <td>{data?.supplierType || '--'}</td>}
                  {selectedColumns?.includes('Category 1') && <td>{data?.catOneId || '--'}</td>}
                  {selectedColumns?.includes('Category 2') && <td>{data?.catTwoId || '--'}</td>}
                  {selectedColumns?.includes('Category 3') && <td>{data?.catThreeId || '--'}</td>}
                  {selectedColumns?.includes('Category 4') && <td>{data?.catFourId || '--'}</td>}

                  <td>
                    <span>
                      <Progress completed={parseFloat(data?.completion || 0)} />
                      <span className="percentage">{data?.completion || 0} %</span>
                    </span>
                  </td>
                  <td>{locationVl || '--'}</td>
                  <td>{fieldLabel || '--'}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="info-container d-flex text-left">
                        <span className="icon-info f-18" />
                        <div className="info-content">
                          <p className="mb-1">
                            <b>{t('COSTING_TO_DO_LIST.CREATED')} :&nbsp;</b>
                            {moment(data.createdAt).format('DD-MM-YYYY, h:mm a')}
                          </p>
                          <p className="mb-1">
                            <b>{t('COSTING_TO_DO_LIST.CREATED_BY')} :&nbsp;</b>

                            {data?.createdBy?.name}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                {data?.isExpanded && (
                  <SupplierTodoExapandView
                    expandData={data?.expandData}
                    toggleExpanfView={toggleExpanfView}
                    isExpanded={data?.isExpanded}
                    item={data}
                    showBigImage={showBigImage}
                    hideImage={hideImage}
                    selectedColumns={selectedColumns}
                    t={t}
                    isSupplierLoggedIn={isSupplierLoggedIn}
                    subBrandAccess={subBrandAccess}
                  />
                )}
              </>
            );
          })}
        {loading && (
          <tr>
            <td colSpan={8 + (selectedColumns?.length || 0)}>
              <Loader />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  ) : (
    <p className="text-center p-4">{t('COSTING_TO_DO_LIST.NO_RECORD_FOUND')}</p>
  );
}
export default SupplierList;
